module.exports = __webpack_public_path__ + "img/check-naranja-1.01ae89b1.svg";